export type FormCapabilities = {
  hasEmploymentDetails: boolean
  hasBackgroundCheck: boolean
  hasPetDetails: boolean
  hasStudentDetails: boolean
  hasAbout: boolean
  hasOtherInfo: boolean
  hasEmergencyContacts: boolean
  hasBondLoanInformation: boolean
  hasVirtualTourViewing: boolean
  hasViewingCheckIn: boolean
  hasPostingClause: boolean
  hasAddressHistoryRent: boolean
  hasAddressHistoryOccupancy: boolean
  hasAddressHistoryArrangement: boolean
  hasReasonForLeaving: boolean
  hasTenure: boolean
  hasRentalReferenceRequests: boolean
  hasRequest: boolean
  hasSavingsBalance: boolean
  hasLeaseDetails: boolean
  hasSnugMatchScore: boolean
  hasDateOfBirth: boolean
  isSAPrescribedForm: boolean
  canMerge: boolean
  canMergeDisabledReason?: string
  canMove: boolean
  canMoveDisabledReason?: string
}

export const defaultFormCapabilities: FormCapabilities = {
  hasEmploymentDetails: true,
  hasBackgroundCheck: true,
  hasPetDetails: true,
  hasStudentDetails: true,
  hasAbout: true,
  hasOtherInfo: true,
  hasEmergencyContacts: true,
  hasBondLoanInformation: true,
  hasVirtualTourViewing: true,
  hasViewingCheckIn: true,
  hasPostingClause: true,
  hasAddressHistoryRent: true,
  hasAddressHistoryOccupancy: true,
  hasAddressHistoryArrangement: true,
  hasReasonForLeaving: true,
  hasTenure: true,
  hasRentalReferenceRequests: true,
  hasRequest: true,
  hasSavingsBalance: true,
  hasLeaseDetails: true,
  hasSnugMatchScore: true,
  hasDateOfBirth: true,
  isSAPrescribedForm: false,
  canMerge: true,
  canMove: true,
}

export const resolveFormCapabilities = (
  formCapabilities: Partial<FormCapabilities> = {},
): FormCapabilities => ({
  ...defaultFormCapabilities,
  ...(formCapabilities || {}),
})
